import React from 'react';
import 'twin.macro';
import { useEDTsTrash } from '@teetsh/app/src/containers/UserSettings/Trash/EDT/useEDTsTrash';
import { useRestoreEDT } from '@teetsh/app/src/containers/UserSettings/Trash/EDT/useRestoreEDT';
import { useTranslation } from 'react-i18next';
import { RestorableList } from '@teetsh/app/src/containers/UserSettings/Trash/components/RestorableList';
import { RestorableEmploiDuTemps } from '@teetsh/app/src/types/edt';

function Details({ nbOfSeances }: RestorableEmploiDuTemps) {
  const { t } = useTranslation(['userSettings']);

  return (
    <div tw="text-right font-light">
      {t('userSettings:restore.list.nbOfSeances', {
        count: nbOfSeances,
      })}
    </div>
  );
}

export function EDTRestorableList() {
  const { data = [] } = useEDTsTrash();
  const restore = useRestoreEDT();

  return (
    <RestorableList<RestorableEmploiDuTemps>
      items={data}
      restore={restore}
      cardFileDetails={Details}
      tableFileDetails={({ row }) => Details(row.original)}
    />
  );
}
